import { Texture } from "@pixi/core";
import { Sprite } from "@pixi/sprite";
import { Event } from "event-system";
import { gsap } from "gsap";
import { Language } from "../../common/Language";
import { AudioManager } from "../../../audio/AudioManager";
import { ScaleUpButton } from "../../common/components/buttons/ScaleUpButton";
export class LanguageElement extends ScaleUpButton {
    public readonly onSelectLanguage: Event<LanguageElement> = new Event<LanguageElement>();

    private shine: Sprite;
    private isSelected: boolean = false;

    public constructor(
        flagTexture: Texture,
        private readonly shineTexture: Texture,
        public readonly language: Language,
        audioManager: AudioManager
    ) {
        super({ defaultTexture: flagTexture }, audioManager);
        this.eventMode = `static`;
        this.build();
        this.layout();
        this.unselect();
        this.hoverAnimation = new gsap.core.Timeline({ paused: true });
    }

    public unselect(): void {
        this.isSelected = false;
        this.shine.visible = false;
    }

    public select(): void {
        this.isSelected = true;
        this.shine.visible = true;
        this.onSelectLanguage.emit(this);
    }

    private build(): void {
        this.shine = new Sprite(this.shineTexture);
        this.addChild(this.shine);
    }

    private layout(): void {
        this.shine.position.set(-5, -12);
    }

    protected override handleUp(): void {
        if (this.isSelected) {
            return;
        }
        super.handleUp();
        this.select();
    }

    protected async handleHover(): Promise<void> {
        if (this.isSelected) {
            return;
        }
        super.handleHover();
    }
}